/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MsgsToUserService } from '../msgs-to-user.service';
import { MsgToUser } from './models/MsgToUser.model';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'lib1-msgs-to-user',
  templateUrl: './msgs-to-user.component.html',
  styleUrls: ['./msgs-to-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MsgsToUserComponent implements OnInit {

  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  msgToUser!: MsgToUser;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private msgsToUserService: MsgsToUserService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {

    this.registerSubscribers();

  }

  registerSubscribers() {

    this.msgsToUserService.msgToUserAsObservable.subscribe((msgToUser: MsgToUser) => {

      if (msgToUser && msgToUser.message != null && msgToUser.message != "") {

        // this.sideBarOpen = false;
        this.msgToUser = msgToUser;

        this.openSnackBarUsingMsgToUser(msgToUser);
        //this.openSnackBar();

      } else {

        this._snackBar.dismiss();
        // this.sideBarOpen = true;
      }

    });
  }

  //For ref:
  //https://material.angular.io/components/snack-bar/examples
  openSnackBarOriginal() {

    this._snackBar.open('Cannonball!!', 'Splash', {

      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,

    });

  }

  //https://stackblitz.com/edit/angular-mdyher-fctxtf?file=app%2Fsnack-bar-component-example.ts
  openSnackBar() {

    const snackBar = this._snackBar.openFromComponent(DismissSnakComponent, {
      data: { preClose: () => { snackBar.dismiss() } }
    });

  }

  openSnackBarUsingMsgToUser(msgToUser: MsgToUser) {

    this._snackBar.open(msgToUser.message, 'Close', {

      horizontalPosition: 'center', // this.horizontalPosition,
      verticalPosition: 'top', //this.verticalPosition,

      //https://anglesvar.medium.com/add-custom-css-to-material-snackbar-91ed36b48fba
      panelClass: ['red-snackbar', 'login-snackbar'],
    });

  }

}

//https://stackblitz.com/edit/angular-mdyher-fctxtf?file=app%2Fsnack-bar-component-example.ts
@Component({
  selector: 'app-upload-progress-snackbar',
  template: `
  Hello :)
  <button mat-button color="primary" (click)="dismiss()">Dismiss</button>
  `,

})
export class DismissSnakComponent {

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any) { }

  dismiss() {

    console.log(this.data);
    this.data.preClose();
  }
}
